import { library, dom, config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';

import {
  faShieldHalved,
  faBugSlash,
  faCertificate,
  faUserShield,
  faLifeRing,
  faMagnifyingGlassLocation,
  faBullhorn,
  faChess,
  faHandshake,
  faLocationDot,
  faPhoneFlip,
  faEnvelope,
  faMagnifyingGlass,
  faBullseye,
  faCartShopping,
  faGears,
  faGlobe,
  faPalette,
  faCircleCheck,
  faStar,
  faArrowRight,
  faLightbulb,
  faCode,
  faCheck,
  faUserLock,
  faMicrochip,
  faBrain,
  faFileSignature,
  faComments,
  faKey,
  faLaptopCode,
  faFileInvoiceDollar,
  faMagnifyingGlassPlus,
  faRobot,
  faDatabase,
  faCodeBranch,
  faChartLine,
  faLayerGroup,
  faMobileScreenButton,
} from '@fortawesome/free-solid-svg-icons';

import {
  faWhatsapp,
  faInstagram,
  faFacebookF,
  faLinkedin,
  faLinkedinIn,
  faVimeoV,
  faYoutube,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';

config.autoAddCss = false;

library.add(
  faShieldHalved,
  faBugSlash,
  faCertificate,
  faUserShield,
  faLifeRing,
  faMagnifyingGlassLocation,
  faBullhorn,
  faChess,
  faHandshake,
  faLocationDot,
  faPhoneFlip,
  faEnvelope,
  faMagnifyingGlass,
  faBullseye,
  faCartShopping,
  faGears,
  faGlobe,
  faPalette,
  faCircleCheck,
  faStar,
  faArrowRight,
  faLightbulb,
  faCode,
  faCheck,
  faUserLock,
  faMicrochip,
  faBrain,
  faFileSignature,
  faComments,
  faKey,
  faLaptopCode,
  faFileInvoiceDollar,
  faMagnifyingGlassPlus,
  faRobot,
  faDatabase,
  faCodeBranch,
  faChartLine,
  faLayerGroup,
  faMobileScreenButton,
  faWhatsapp,
  faInstagram,
  faFacebookF,
  faLinkedin,
  faLinkedinIn,
  faVimeoV,
  faYoutube,
  faTwitter
);

dom.watch();
